/**
 * Login Route
 *
 * Login page with Google OAuth and email/password form.
 * Uses the LoginPage component from Story 1.4.
 *
 * 29-24: honors a `next` param (the MCP consent screen sends logged-out users
 * here as /login?next=<authorize url>). After login, a SAFE next resumes that
 * flow — for the cross-subdomain MCP authorize URL that means a full-page
 * navigation. Everything else falls back to /clients.
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { LoginPage } from "../../pages/auth";
import { safeNext, isExternalNext } from "../../lib/safe-next";

export const Route = createFileRoute("/_auth/login")({
  component: LoginRoute,
});

function LoginRoute() {
  const navigate = useNavigate();

  const handleSuccess = () => {
    const next = safeNext(new URLSearchParams(window.location.search).get("next"));
    if (next && isExternalNext(next)) {
      // Cross-subdomain (mcp.provenleap.com/oauth/authorize) — full navigation
      // so the session cookie is sent and the consent screen renders.
      window.location.assign(next);
      return;
    }
    navigate({ to: next ?? "/clients" });
  };

  return <LoginPage onSuccess={handleSuccess} />;
}
